// Helper function to check if a store exists
import {SessionManager} from "../../infrastructure/storage/SessionManager";
import {generateGuid} from "./utils";

const SONGS_WORKSPACE_PREFIX = 'songs-storage-';

// Helper functions
const getDefaultSessionId = () => {
  let id = localStorage.getItem('defaultSessionId');
  if (!id) {
    id = generateGuid();
    localStorage.setItem('defaultSessionId', id);
  }
  return id;
};

const getWorkspaceId = () => {
  const currentSession = process.env.REACT_APP_HOSANNA_READONLY === '1'
    ? SessionManager.getCredentialSession() : SessionManager.getCurrentSession();
  const sessionId = currentSession?.id || getDefaultSessionId();
  return `${SONGS_WORKSPACE_PREFIX}${sessionId}`;
};

const getWorkspaceIdForSession = (sessionId) => {
  const resolvedSessionId = sessionId || getDefaultSessionId();
  return `${SONGS_WORKSPACE_PREFIX}${resolvedSessionId}`;
};

export {getDefaultSessionId, getWorkspaceId, getWorkspaceIdForSession};
